import { CardProject } from "../../components/cardProject/CardProject";
import projects from "../../projects";
import "./projects.scss";

export const Projects = () => {
  return (
    <div className="projects"  id="projects" style={{textAlign: "center"}}>
      <h2 style={{margin: "20px 0 60px 0"}} >Projects</h2>
      <div className="section" >
        {projects.map((project) => (
          <CardProject project={project} />
        ))}
      </div>
    </div>
  );
};
